<template>
  <div class="dialog-container">
    <el-dialog
      :title="title"
      :visible.sync="visible"
      :modal-append-to-body="false"
      :append-to-body="true"
      :close-on-click-modal="false"
      @close="closePop"
      :modal="modal"
      :width="width"
      :show="show"
      :class="classes">
      <slot></slot>
      <slot name="shoucang" ></slot>
      <slot name="shoucang-btn"></slot>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        visible: this.show
      }
    },
    props: {
      show: {
        type: Boolean,
        default: false
      },
      modal: {
        type: Boolean,
        default: true
      },
      title: {
        type: String,
        default: ''
      },
      width: {
        type: String,
        default: '50%'
      },
      classes:{
        type: String,
        default: ''
      }
    },
    watch: {
      show () {
        this.visible = this.show
      }
    },
    methods: {

      closePop() {
        this.$emit('closePop', false)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// pop.vue?0ec40300